import accountLogic from "./Account/Logic";

export default [...accountLogic];
